

import { BasicProperties } from "../BasicProperties";

export class BasicRegisterDialogProperties extends BasicProperties {
    public username: string;
    public password: string;

}

